"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSynapseToken = void 0;
const tslib_1 = require("tslib");
const cross_fetch_1 = tslib_1.__importDefault(require("cross-fetch"));
const crypto_1 = require("@dcl/crypto");
const errors_1 = require("./errors");
async function getSynapseToken(synapseUrl, address, identity) {
    const timestamp = Date.now();
    const authChain = crypto_1.Authenticator.signPayload(identity, timestamp.toString());
    try {
        const response = await (0, cross_fetch_1.default)(`${synapseUrl}/_matrix/client/r0/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                auth_chain: authChain,
                identifier: {
                    type: 'm.id.user',
                    user: address
                },
                timestamp: timestamp.toString(),
                type: 'm.login.decentraland'
            })
        });
        if (response.ok) {
            const responseBody = await response.json();
            return responseBody.access_token;
        }
        else {
            throw new Error(`Synapse server responded with a ${response.status} status code`);
        }
    }
    catch (error) {
        throw new errors_1.SynapseLoginError((0, errors_1.isErrorWithMessage)(error) ? error.message : 'Unknown error');
    }
}
exports.getSynapseToken = getSynapseToken;
//# sourceMappingURL=synapse.js.map